<!-- 基础设施 -->
<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>
    <div class="introduce">
      <p class="sub_title">
        方案应用背景
      </p>
      <div class="content_A">
        关键基础设施行业正在进行数字化转型，业务开展也愈发依赖信息平台，因此对信息安全也提出了更高的要求，
        需要进一步提高安全管理、安全运营水平，优化安全工作流程，缩短安全事件处理响应和分析时间，保障关键基
        础设施行业信息系统安全运行。急需建立符合关键基础设施行业安全业务需要的大数据支撑平台，为安全技术人
        员及时进行安全事件响应、快速准确分析安全事件提供平台支撑；为各级安全管理人员提供安全工作决策依据。
      </div>
    </div>
    <div class="introduce background">
      <p class="sub_title">
        问题分析
      </p>
      <div class="analyses">
        <div class="content_S">
          <div
            v-for="item in analyses"
            :key="item.id"
            class="listS"
          >
            <div class="top_list">
              <div class="number">
                {{ item.id }}
              </div>
              <div class="number_title">
                {{ item.title }}
              </div>
            </div>

            <div class="list">
              <ul
                v-for="text in item.lists"
                :key="text"
              >
                <li>
                  {{ text }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="introduce">
      <p class="sub_title">
        解决方案
      </p>
      <div class="solution">
        <div class="solutionDetail">
          <img
            src="@/assets/solution/infrastructure/zu13.png"
            alt=""
          >
        </div>
      </div>
    </div>
    <div class="introduce">
      <p class="sub_title">
        方案价值及意义
      </p>

      <div class="meaning">
        <div class="meaning_lists">
          <div
            v-for="item in meaning"
            :key="item.id"
            class="meaning_list"
          >
            <img
              :src="item.img"
              alt=""
            >
            <div class="meaning_text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: '',

  data() {
    return {
      title: '关键基础设施行业——态势感知场景解决方案',
      subtitle: '---关键基础设施行业应用案例',
      analyses: [
        {
          id: 1,
          title: '数据处理能力不足',
          lists: [
            '互联网出口统一，数据量大；',
            '缺少数据综合治理能力.'

          ]
        },
        {
          id: 2,
          title: '数据集中',
          lists: [
            '缺少统一的数据存储平台；',
            '缺少富化、归类、检索等技术应用.'

          ]
        },
        {
          id: 3,
          title: '综合分析',
          lists: [
            '缺少数据的关联分析能力;',
            '缺少人物画像的构建能力.'

          ]
        },
        {
          id: 4,
          title: '安全态势呈现',
          lists: [
            '缺少安全态势的关联分析；',
            '缺少安全态势的大屏展现.'
          ]

        }

      ],
      meaning: [
        {
          id: 1,
          img: require('@/assets/solution/infrastructure/tubiao-dashboard.png'),
          text: '整合并存储网络安全大数据满足合法和合规，并为后期大数据分析提供数据基础'
        },
        {
          id: 2,
          img: require('@/assets/solution/infrastructure/yunxiazai-download.png'),
          text: '具备智能回溯与分析能力，出现安全问题能快速分析并找出'
        },
        {
          id: 3,
          img: require('@/assets/solution/infrastructure/gongneng-function.png'),

          text: '缩短网络安全事件响应、处理和分析时间，提升应急响应能力'
        },
        {
          id: 4,
          img: require('@/assets/solution/infrastructure/yunfuwu-cloudserver.png'),

          text: '实现关键基础设施行业网络安全威胁可视化，网络安全态势一目了然'
        }
      ]
    }
  }

}
</script>

<style lang="less" scoped>
.page_html {
  width: 100%;
  background: #fff;

  .banner {
    width: 100wh;
    height: 550px;

    img {
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 80%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 80%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 50px;
      }

    }
  }

  .analyses {
    width: 100%;
    padding-top: 73px;

    .content_S {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .listS {
        width: 24%;
        height: 480px;
        border-radius: 30px;
        background: rgba(233, 239, 253, 1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

      }

      .top_list {
        width: 218px;
        height: 91px;
        background: #83A8F0;
        border-radius: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .number {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 40px;
        }

        .number_title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 40px;
        }

      }

      .list {
        width: 218px;
        height: 310px;
        background: #83A8F0;
        border-radius: 30px;

        li {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 40px;
        }

      }

    }
  }

  .background {
    background: #FAFBFF;
    padding: 77px 0 118px;
  }

  .solution {
    width: 70%;
    margin: 0 auto;
    margin-bottom: 84px;

    .solutionDetail {
      width: 100%;
      height: 700px;
      display: flex;
      justify-content: center;
    }
  }

  .meaning {
    width: 70%;
    margin: 0 auto 102px;
    padding-top: 40px;

    .meaning_lists {
      display: flex;
      justify-content: space-between;
    }

    .meaning_list {
      width: 24%;
      height: 526px;
      background: RGBA(237, 242, 253, 1);
      border-radius: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 100px;
        height: 100px;
        margin: 50px 0 102px;
      }

      .meaning_text {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        margin: 0 49px;
        text-align-last: center;
      }
    }
  }

}

@media (max-width: 750px)and (max-width: 1250px) {
  .banner .banner_Title .title {
    width: 74% !important;
  }

  .page_html .banner .banner_Title .title {
    font-size: 30px !important;
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .introduce .content_A{
    font-size: 20px;
  }
  .page_html .analyses .content_S .top_list .number_title{
    font-size: 20px;
  }
  .page_html .analyses .content_S .list li{
     font-size: 20px;
  }

  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 37px !important;
  }

  .banner{
    height: 400px !important;
  }

  .banner .banner_Title .subtitle {
    font-size: 20px !important;
  }

  .page_html .meaning .meaning_list img {
    margin: 50px 0 30px !important;
  }

  .page_html .meaning .meaning_list .meaning_text {
    font-size: 16px !important;
  }

  .page_html .meaning {
    width: 85% !important;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {

  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 40px !important;
  }
  .page_html .analyses .content_S .top_list .number_title,
  .page_html .analyses .content_S .list li
  {
    font-size: 22px !important;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px !important;
  }

  .banner{
    height: 450px !important;
  }

  .page_html .meaning {
    width: 80% !important;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .banner .banner_Title .title {
    width: 90% !important;
    font-size: 52px !important;
  }

  .page_html .meaning {
    width: 75% !important;
  }

   .banner .banner_Title .subtitle {
    font-size: 30px !important;
  }

}
</style>
